import clsx from 'clsx'
import { avatarHue, initials } from '@/lib/format'
import styles from './Avatar.module.scss'

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export interface AvatarProps {
  name: string | null | undefined
  src?: string | null
  size?: AvatarSize
  /** Shows an online/offline dot. */
  status?: 'online' | 'offline'
  className?: string
  title?: string
}

export function Avatar({ name, src, size = 'md', status, className, title }: AvatarProps) {
  const label = name || 'Unknown'
  return (
    <span
      className={clsx(styles.avatar, styles[size], className)}
      style={{ ['--hue' as string]: avatarHue(label) }}
      title={title ?? label}
      aria-label={label}
      role="img"
    >
      {src ? <img className={styles.img} src={src} alt="" /> : initials(label)}
      {status && <span className={clsx(styles.status, status === 'offline' && styles.statusOff)} aria-hidden="true" />}
    </span>
  )
}

export interface AvatarGroupProps {
  people: Array<{ name: string | null | undefined; src?: string | null; id?: string | number }>
  size?: AvatarSize
  max?: number
  className?: string
}

export function AvatarGroup({ people, size = 'sm', max = 3, className }: AvatarGroupProps) {
  const shown = people.slice(0, max)
  const extra = people.length - shown.length
  return (
    <span className={clsx(styles.group, className)}>
      {shown.map((p, i) => (
        <Avatar key={p.id ?? `${p.name}-${i}`} name={p.name} src={p.src} size={size} />
      ))}
      {extra > 0 && (
        <span className={clsx(styles.avatar, styles[size], styles.more)} title={`${extra} more`}>
          +{extra}
        </span>
      )}
    </span>
  )
}
